export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;
